import { useState } from "react";
import { CoalitionSection } from "../CoalitionSection";
import { CoalitionModal } from "../CoalitionModal";
import { CoalitionCardExtras } from "../CoalitionCardExtras";
import { CoalitionCardExtrasDetail } from "..";
import { empty_extras } from "../../pngs";
import { EmptyBlock } from "./EmptyBlock";
import { sendTag, event_properties_101_05 } from "../CoalitionGtm";
import { privGtmKey, toggleScrollLock, getCardDetail } from "../../utils";

export const ExtrasBlock = ({ extraPoints }) => {
  const [modal, setModal] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const gtm = localStorage.getItem(privGtmKey);

  const toggleModal = (cardId = null) => {
    setIsShown(Boolean(cardId));
    toggleScrollLock();
    setActiveCard(getCardDetail(extraPoints, cardId));
  };
  const showModalFn = (cardId, k, i) => {
    toggleModal(cardId);
    if (gtm) {
      let payload = event_properties_101_05();
      payload.extra_points_id = i.id;
      payload.banner_index = k;
      sendTag(gtm, payload);
    }
  };

  const title = "Gana puntos adicionales";
  const emptyDesc =
    "Muy pronto podrás ganar más puntos en el total de tu compra";
  const filledDesc =
    "Gana más puntos en el total de tu∆ compra al elegir productos participantes";
  const modalTitle = "Todo sobre puntos adicionales";

  return (
    <>
      {!extraPoints || extraPoints.length === 0 ? (
        <EmptyBlock
          title={title}
          description={emptyDesc}
          emptyState={empty_extras}
          isBlock={true}
        />
      ) : (
        <>
          <CoalitionSection title={title} subtitle={filledDesc}>
            {extraPoints.map((i, k) => (
              <CoalitionCardExtras
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                expiracy={i.valid_until}
                extraPoints={i.extra_points}
                showModal={(cardId, k) => showModalFn(cardId, k, i)}
              />
            ))}
          </CoalitionSection>
          {isShown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={modalTitle}
            >
              <CoalitionCardExtrasDetail card={activeCard} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
